/**
 * @fileOverview Authorization: login, logout etc
 * @author Ananda Masri
 */


import moduleDefault from '@aamasri/web-components/src/js/sha1';
export function sha1(msg) {
	return moduleDefault(msg);
}



// detect any caching issues and force a browser reload to fix incorrect logged-in status
export function syncLoginState() {
	if (/\/login\/email\//.test(window.location.href))
		return;		// this page is going to redirect in a few seconds - don't reload here to avoid an endless loop

	const debug = false;

	if (debug) console.debug(`forceLoginState start...`);

	if (typeof localStorage !== 'object')
		return;

	if (typeof visitorId !== 'undefined') {
		try {	// just because this is a persistently buggy bit of code
			if (debug) console.debug(`  visitorId: ${visitorId}, localStorage.visitorId: ${localStorage.visitorId || 'undefined'}`);

			// logged-in user status hasn't been saved yet
			if (!localStorage['visitorId']) {
				localStorage.setItem('visitorId', visitorId || 0);
				if (debug) console.debug(`  set localStorage.visitorId = ${visitorId}`);
			}
			// reload if visitorId mismatch (can happen when navigating cached pages following login/logout)
			else if ((visitorId || 0).toString() !== (localStorage.getItem('visitorId') || '0') && typeof localStorage.forcingReload === 'undefined') {
				if (debug) console.debug(`Logged in user mismatch: visitorId(${visitorId || 0}) !== localStorage.visitorId(${localStorage.visitorId || 0})`);
				localStorage.setItem('visitorId', visitorId || 0);
				localStorage.setItem('forcingReload', 'true');
				reloadPage();
			} else if (localStorage.forcingReload) {
				localStorage.removeItem('forcingReload');
				if (debug) console.debug(`  has successfully reloaded`);
			}

			if (debug) console.debug(`...forceLoginState end`);
		} catch (error) {
			console.error(error);
		}
	}
}




export function logout() {
	import(/* webpackChunkName: "busy" */ '@aamasri/busy')
		.then(busy => {
			busy.start('Logging Out', 10, true);
			jQuery.post('/login/ajaxLogout').done(() => {
				busy.stop('Logging Out');

				import(/* webpackChunkName: "dialog" */ '@aamasri/dialog').then(dialog => {
					dialog.closeAll();
					localStorage.setItem('visitorId', '');     // to prevent a browser reload loop
					localStorage.setItem('forcingReload', 'true');
					window.location.reload();
				});
			});
		})
		.catch(error => { throw `loading busy failed with: ${error.message}`; });
}



export function loginPrompt() {
	import(/* webpackChunkName: "busy" */ '@aamasri/busy')
		.then(busy => {
			if (busy.queue.length)
				window.setTimeout(loginPrompt, 1000);	// try again in a moment
			else {
				jQuery('div.growlBox').remove();	// close any open growl messages
				import(/* webpackChunkName: "dialog" */ '@aamasri/dialog').then(dialog => {
					dialog.closeAll();					// close any open popup dialogs
					popupLoginDialog();					// display login popup
				});
			}
		})
		.catch(error => { throw `loading busy failed with: ${error.message}`; });
}



// if visitor is logged out but requires authentication to access the page, automatically popup a login dialog box.
export function checkAccess() {
	if (!jQuery('.disableLoginPopup').length && (jQuery('[onclick*="popupLoginDialog"]').length > 1 || jQuery('.forceLoginPopup').length))
		window.setTimeout(popupLoginDialog, 5000);
}



// open the login form in a dialog box
export function popupLoginDialog() {
	// login needs cookies. Skip if login box already open.
	if (!document.querySelector('#loginForm')) {
		import(/* webpackChunkName: "dialog" */ '@aamasri/dialog').then(dialog => {
			if (navigator.cookieEnabled)
				dialog.open({
					title: 'Login',
					source: '/login?_=' + Math.round(Math.random() * 10000),
					persistent: true,
					modal: true
				}).then();
			else
				dialog.open({ title: 'Login', source: 'Login requires cookies to be enabled! Please check your browser settings and any browser security plugins.', modal: true }).then();
		});
	}
}




export function adminPasswordReset(userId, fullName, email) {
	if (typeof userId === 'undefined' || !parseInt(userId))
		alert('System error: the user was not specified');

	dialog.open({
		title: 'Send a Login Link',
		source: `<p>Please confirm you want to send a login link to:<br><br>${fullName} &lt;${email || 'missing email address'}&gt;</p>
		<div class="footer">
			<button class="btn btn-primary" onclick="dialog.close(this); Post.Send('userId=${userId}', '/login/adminPasswordReset');">Confirm</button>
			<button class="btn" onclick="dialog.close(this);">Cancel</button>
		</div>`,
		modal: true
	}).then();
}




